<template>
  <div>
    <div class="details-title">{{ title }}</div>
    <div class="card card-body card-account bg-light">
      <div class="row">
        <div class="col-md-8">
          <p>
            {{ accountData.address }}
            {{ accountData.postcode }}
            {{ accountData.city }}
          </p>
        </div>
        <div class="col-md-5 text-right">
          <div @click="$bvModal.show('delivery-details-modal')" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <b-modal ref="delivery-details-modal" id="delivery-details-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-13">
                <label for="address" class="col-form-label">Adres</label>
                <input
                  id="address"
                  name="address"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.address.$error}"
                  v-model="address"
                  @blur="$v.address.$touch()"
                  placeholder="Adres"
                >
                <span v-if="$v.address.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. het adres in.</strong>
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-5">
                <label for="postcode" class="col-form-label">Postcode</label>
                <input
                  id="postcode"
                  name="postcode"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.postcode.$error}"
                  v-model="postcode"
                  @blur="$v.postcode.$touch()"
                  placeholder="1234AB"
                >
                <span v-if="$v.postcode.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. de postcode in.</strong>
                </span>
              </div>
              <div class="col-md-8">
                <label for="city" class="col-form-label">Plaats</label>
                <input
                  id="city"
                  name="city"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.city.$error}"
                  v-model="city"
                  @blur="$v.city.$touch()"
                  placeholder="Plaats"
                >
                <span v-if="$v.city.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. de plaats in.</strong>
                </span>
              </div>
            </div>
          </form>
        </div>

        <div
          v-if="deliveryDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': deliveryDetailsStatus.success, 'alert-danger': !deliveryDetailsStatus.success }"
        >
          <strong>{{ deliveryDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
          class="btn btn-oldevuuren btn-round w-100">
          {{ title }} opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="deliveryDetailsBusy" icon="spinner" spin/>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { minLength, required } from 'vuelidate/lib/validators'

  import { MUTATE_DELIVERY_DETAILS_STATUS, SAVE_DELIVERY_DETAILS } from '../../../store/types'

  export default {
    props: ['accountData'],
    data() {
      return {
        title: 'Afleveradres',
        address: this.accountData.address,
        postcode: this.accountData.postcode,
        city: this.accountData.city
      }
    },
    validations: {
      address: {
        required,
        minLen: minLength(2)
      },
      postcode: {
        required,
        minLen: minLength(6)
      },
      city: {
        required,
        minLen: minLength(6)
      }
    },
    computed: {
      deliveryDetailsStatus() {
        return this.$store.getters.deliveryDetailsStatus
      },
      deliveryDetailsBusy() {
        return this.$store.getters.deliveryDetailsBusy
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['delivery-details-modal'].hide()
        // discard changes
        this.address = this.accountData.address
        this.postcode = this.accountData.postcode
        this.city = this.accountData.city
      },
      saveDetails() {
        const formData = {
          address: this.address,
          postcode: this.postcode,
          city: this.city
        }
        this.$store.dispatch(SAVE_DELIVERY_DETAILS, formData).then(() => {
          if (this.deliveryDetailsStatus.success) {
            this.$refs['delivery-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_DELIVERY_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
